import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/play.svg'
import _imports_1 from '@/assets/img/graphic/file.svg'


const _withScopeId = n => (_pushScopeId("data-v-38a98548"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "video-player--play",
  src: _imports_0,
  alt: "play icon"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "file" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "casedrive file"
}, null, -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "file-wrapper" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "video-player--play",
  src: _imports_0,
  alt: "play icon"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "file" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "casedrive file"
}, null, -1))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_skeleton_rect = _resolveComponent("app-skeleton-rect")!
  const _component_drive_ui_wrapper = _resolveComponent("drive-ui-wrapper")!
  const _component_upload_files_pop_up = _resolveComponent("upload-files-pop-up")!
  const _component_upload_photos_pop_up = _resolveComponent("upload-photos-pop-up")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createBlock(_component_drive_ui_wrapper, {
        key: 0,
        title: _ctx.title,
        hideBorder: _ctx.hideBorder
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_ctx.isPreviewCase && !_ctx.isUserPublicCase)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin),
                  ref: "fileInputButton",
                  class: _normalizeClass(["file-button", [_ctx.isPhoto ? 'photo' : 'file-box', _ctx.disabled ? 'disabled' : '']]),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPopUp && _ctx.openPopUp(...args)))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["icon", _ctx.isPhoto ? 'icon-plus' : 'icon-plus'])
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(_ctx.$localize('drive.file.add')) + " " + _toDisplayString(_ctx.isPhoto ? _ctx.$localize('drive.file.type.photo') : _ctx.$localize('drive.file.type.file')), 1)
                ], 6))
              : (_openBlock(), _createElementBlock("h3", {
                  key: 1,
                  class: _normalizeClass(_ctx.isPhoto ? 'no-photo-text' : 'no-file-text')
                }, _toDisplayString(_ctx.$localize('drive.file.no.added.text1')) + " " + _toDisplayString(_ctx.isPhoto ? _ctx.$localize('drive.file.type.photo') : _ctx.$localize('drive.file.type.file')) + " " + _toDisplayString(_ctx.$localize('drive.file.no.added.text2')), 3)),
            (_ctx.isPhoto)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skeletonAmount, (n) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: n,
                      class: "photo",
                      style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin)
                    }, [
                      _createVNode(_component_app_skeleton_rect)
                    ], 4))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (photo) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: photo.id,
                      class: "photo",
                      style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin)
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.resolvePhoto(photo),
                        alt: "selected photo"
                      }, null, 8, _hoisted_2),
                      (photo.type === 'VIDEO')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.removeItem(photo)),
                        class: "closer"
                      }, _hoisted_6, 8, _hoisted_4)
                    ], 4))
                  }), 128))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skeletonAmount, (n) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: n,
                      class: "file-box",
                      style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin)
                    }, [
                      _createVNode(_component_app_skeleton_rect)
                    ], 4))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: file.id,
                      style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin),
                      class: "file-box"
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", {
                          onClick: ($event: any) => (_ctx.removeItem(file)),
                          class: "closer"
                        }, _hoisted_11, 8, _hoisted_9)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(file.name), 1)
                    ], 4))
                  }), 128))
                ], 64))
          ])
        ]),
        _: 1
      }, 8, ["title", "hideBorder"]))
    : (_openBlock(), _createBlock(_component_drive_ui_wrapper, {
        key: 1,
        title: _ctx.title,
        hideBorder: _ctx.hideBorder
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            (!_ctx.isPreviewCase && !_ctx.isUserPublicCase)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin),
                  ref: "fileInputButton",
                  class: _normalizeClass(["file-button", [_ctx.isPhoto ? 'photo' : 'file-box', _ctx.disabled ? 'disabled' : '']]),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDesktopPopUp && _ctx.openDesktopPopUp(...args)))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["icon", _ctx.isPhoto ? 'icon-plus' : 'icon-plus'])
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(_ctx.$localize('drive.file.add')) + " " + _toDisplayString(_ctx.isPhoto ? _ctx.$localize('drive.file.type.photo') : _ctx.$localize('drive.file.type.file')), 1)
                ], 6))
              : (_openBlock(), _createElementBlock("h3", {
                  key: 1,
                  class: _normalizeClass(_ctx.isPhoto ? 'no-photo-text' : 'no-file-text')
                }, _toDisplayString(_ctx.$localize('drive.file.no.added.text1')) + " " + _toDisplayString(_ctx.isPhoto ? _ctx.$localize('drive.file.type.photo') : _ctx.$localize('drive.file.type.file')) + " " + _toDisplayString(_ctx.$localize('drive.file.no.added.text2')), 3)),
            (_ctx.isPhoto)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skeletonAmount, (n) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: n,
                      class: "photo",
                      style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin)
                    }, [
                      _createVNode(_component_app_skeleton_rect)
                    ], 4))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (photo) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: photo.id,
                      class: "photo",
                      style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin)
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.resolvePhoto(photo),
                        alt: "selected photo"
                      }, null, 8, _hoisted_13),
                      (photo.type === 'VIDEO')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.removeItem(photo)),
                        class: "closer"
                      }, _hoisted_17, 8, _hoisted_15)
                    ], 4))
                  }), 128))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skeletonAmount, (n) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: n,
                      class: "file-box",
                      style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin)
                    }, [
                      _createVNode(_component_app_skeleton_rect)
                    ], 4))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: file.id,
                      style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin),
                      class: "file-box"
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", {
                          onClick: ($event: any) => (_ctx.removeItem(file)),
                          class: "closer"
                        }, _hoisted_22, 8, _hoisted_20)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(file.name), 1)
                    ], 4))
                  }), 128))
                ], 64)),
            (_ctx.showPopUp && !_ctx.isPhoto)
              ? (_openBlock(), _createBlock(_component_upload_files_pop_up, {
                  key: 4,
                  "files-pop-up-pos": _ctx.filesPopUpPos,
                  onClose: _ctx.hidePopUp
                }, null, 8, ["files-pop-up-pos", "onClose"]))
              : _createCommentVNode("", true),
            (_ctx.showPopUp && _ctx.isPhoto)
              ? (_openBlock(), _createBlock(_component_upload_photos_pop_up, {
                  key: 5,
                  onClose: _ctx.hidePopUp,
                  "photos-pop-up-pos": _ctx.filesPopUpPos
                }, null, 8, ["onClose", "photos-pop-up-pos"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["title", "hideBorder"]))
}